'use strict';

import './bots.list.ctrl';
import './bots.info.ctrl';

export default angular
  .module('main.bots', [
    'main.botsList.controller',
    'main.botsInfo.controller'
  ])
  .name;
